/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UploadFirmware$Params {
      body?: {

/**
 * the version of the uploaded firmware
 */
'version'?: string;
'routerTypeId'?: number;

/**
 * The firmware update file
 */
'firmwareFile'?: Blob;

/**
 * The name of the file that is uploaded
 */
'firmwareFileName'?: string;

/**
 * An optional short description for the file. It is recommended to add a description
 */
'description'?: string;
}
}

export function uploadFirmware(http: HttpClient, rootUrl: string, params?: UploadFirmware$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, uploadFirmware.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

uploadFirmware.PATH = '/firmwares';
